import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

export const [ChargeKinds, ChargeKindSchema] = EnumBuilder(
  'preliminary',
  'final'
)
export type ChargeKind = ZodInfer<typeof ChargeKindSchema>
